module.exports = __webpack_public_path__ + "img/mobilehardwareOpen7.c5d24eed.png";